import { render, staticRenderFns } from "./profitWithdrawalPoint.vue?vue&type=template&id=ee3fd410&"
import script from "./profitWithdrawalPoint.vue?vue&type=script&lang=js&"
export * from "./profitWithdrawalPoint.vue?vue&type=script&lang=js&"
import style0 from "./profitWithdrawalPoint.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports